import React, { useState, useRef, useEffect } from 'react';
import { Download, FileText, Printer, ChevronDown } from 'lucide-react';
import { sans, coral, coralSoft, useTheme } from '../../tokens';

export default function ExportMenu({ onExportPDF }) {
  const t = useTheme();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const menuItems = [
    {
      label: 'Export PDF Newsletter',
      icon: FileText,
      onClick: () => {
        onExportPDF?.();
        setOpen(false);
      },
    },
    {
      label: 'Print View',
      icon: Printer,
      onClick: () => {
        window.print();
        setOpen(false);
      },
    },
  ];

  return (
    <div ref={containerRef} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '6px 12px',
          borderRadius: 6,
          border: `1px solid ${coral}`,
          background: coralSoft,
          color: coral,
          fontFamily: sans,
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        <Download size={14} />
        Export
        <ChevronDown size={12} style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }} />
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: 4,
            minWidth: 200,
            background: t.bgCard,
            border: `1px solid ${t.border}`,
            borderRadius: 8,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            zIndex: 100,
            overflow: 'hidden',
          }}
        >
          {menuItems.map((item) => (
            <button
              key={item.label}
              onClick={item.onClick}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                width: '100%',
                padding: '10px 14px',
                border: 'none',
                background: 'transparent',
                color: t.textPrimary,
                fontFamily: sans,
                fontSize: 12,
                cursor: 'pointer',
                textAlign: 'left',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = t.bgSurface)}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
              <item.icon size={14} color={t.textSecondary} />
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
